module.exports = __webpack_public_path__ + "img/skeleton-loader.a75d6f5a.svg";